import type { TFunction } from 'i18next'

export function getQuestionTypeLabel(
  questionType: string,
  t: TFunction<'questionnaires'>,
): string {
  switch (questionType) {
    case 'TEXT':
      return t('typeText')
    case 'SINGLE_CHOICE':
      return t('typeSingleChoice')
    case 'MULTIPLE_CHOICE':
      return t('typeMultipleChoice')
    default:
      return questionType
  }
}
